import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNoAgentNotificationStyles } from './NoAgentNotification.styles';
import { VoiceState } from '../../types/VoiceState';

interface NoAgentNotificationProps {
  state: VoiceState;
}

export const NoAgentNotification = ({ state }: NoAgentNotificationProps) => {
  const { classes } = useNoAgentNotificationStyles();
  const { t } = useTranslation();

  if (
    state === VoiceState.LISTENING ||
    state === VoiceState.THINKING ||
    state === VoiceState.SPEAKING
  ) {
    return null;
  }
  return (
    <Typography variant="body2" className={classes.notification}>
      {state === VoiceState.CONNECTING && t('agentPage.status.connectingToAgent')}
      {state === VoiceState.DISCONNECTED && t('agentPage.status.disconnectedFromAgent')}
    </Typography>
  );
};
